import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function DataTable({ columns, data, loading, emptyMessage = 'No data found', onRowClick, page, totalPages, onPageChange }) {
  if (loading) {
    return (
      <div className="card p-12 flex items-center justify-center">
        <div className="spinner w-8 h-8" />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="card p-12 text-center">
        <p className="text-navy-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="card overflow-hidden p-0">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-navy-200">
          <thead className="bg-navy-50">
            <tr>
              {columns.map((col, i) => (
                <th key={i} className="px-5 py-3 text-left text-xs font-medium text-navy-500 uppercase tracking-wider">
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-navy-100">
            {data.map((row, rowIdx) => (
              <tr
                key={row.id || rowIdx}
                className={`${onRowClick ? 'cursor-pointer hover:bg-navy-50' : ''} transition-colors`}
                onClick={() => onRowClick?.(row)}
              >
                {columns.map((col, colIdx) => (
                  <td key={colIdx} className="px-5 py-3.5 text-sm text-navy-700 whitespace-nowrap">
                    {col.render ? col.render(row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="flex items-center justify-between px-5 py-3 border-t border-navy-100 bg-navy-50/50">
          <p className="text-sm text-navy-500">
            Page {page} of {totalPages}
          </p>
          <div className="flex gap-2">
            <button
              onClick={() => onPageChange?.(page - 1)}
              disabled={page <= 1}
              className="p-1.5 rounded-apple hover:bg-navy-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            >
              <ChevronLeft className="h-4 w-4" />
            </button>
            <button
              onClick={() => onPageChange?.(page + 1)}
              disabled={page >= totalPages}
              className="p-1.5 rounded-apple hover:bg-navy-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            >
              <ChevronRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
